import axiosInstance from '../helpers/axios';
import { handleError, handleSuccess } from '../helpers/utils';
import { getToken } from './auth';

// Get dashboard report
export const getDashboardReport = async (month) => {
	const token = getToken();
	return await axiosInstance({
		url: `/api/order/latest-stats?month=${month}&response_type=excel`,
		headers: { Authorization: 'Bearer ' + token },
		method: 'get',
		responseType: 'blob',
	})
		.then((response) => {
			try {
				// URL
				const url = window.URL.createObjectURL(
					new Blob([response.data])
				);

				// Create link
				const link = document.createElement('a');
				link.href = url;
				link.setAttribute('download', 'Reporte_Del_Dashboard.xlsx');

				// Set link
				document.body.appendChild(link);
				link.click();
				handleSuccess('Reporte generado');
			} catch (error) {
				handleError(
					error,
					'Hubo un error al crear el reporte de los pedidos [1]'
				);
			}
		})
		.catch((error) => {
			handleError(
				error,
				'Hubo un error al crear el reporte de los pedidos [2]'
			);
		});
};

// Get dashboard report
export const getDashboardMobileReport = async (data) => {
	const token = getToken();
	return await axiosInstance({
		url: '/api/order/mobile-dashboard',
		headers: { Authorization: 'Bearer ' + token },
		method: 'post',
		data: { data: data },
		responseType: 'blob',
	})
		.then((response) => {
			try {
				// URL
				const url = window.URL.createObjectURL(
					new Blob([response.data])
				);

				// Create link
				const link = document.createElement('a');
				link.href = url;
				link.setAttribute('download', 'Reporte_Del_Dashboard.xlsx');

				// Set link
				document.body.appendChild(link);
				link.click();
				handleSuccess('Reporte generado');
			} catch (error) {
				handleError(
					error,
					'Hubo un error al crear el reporte de los pedidos [1]'
				);
			}
		})
		.catch((error) => {
			handleError(
				error,
				'Hubo un error al crear el reporte de los pedidos [2]'
			);
		});
};
